

export const ROLE_OPTIONS = [
    { value: "admin", label: "Admin" },
    { value: "medicineadmin", label: "Medicine Admin" },
    { value: "diagnosticadmin", label: "Diagnostic Admin" },
    { value: "deliveryagent", label: "Delivery Person" },
    { value: "staff", label: "Staff" },
  ];
  